/* global jQuery */
import jQuery from 'jquery';
import Svg4Everybody from 'svg4everybody';
// import Ps from 'perfect-scrollbar';
// import Select2 from 'select2';
import objectFitImages from 'object-fit-images';

// Relative Imports
import Authors from './modules/authors';
import BBPress from './modules/bbpress';
import CardBlock from './modules/card-block';
import Filters from './modules/filters';
import Form from './modules/form';
import Header from './modules/header';
import SocialSharing from './modules/social-sharing';
import SteppedCTA from './modules/stepped-cta';
import SubMenu from './modules/sub-menu';

(function ($) {
    const debug = true;
    const mobileBreakpoint = 767;

    /**
     * Authors Accordion
     */
    new Authors();

    /**
     * BBPress functions
     */
    new BBPress();

    /**
     * CardBlock Show more
     */
    new CardBlock();

    /**
     * Filters
     */
    new Filters('.js-filters');

    /**
     * Form
     */
    new Form();

    /**
     * Header
     */
    new Header(mobileBreakpoint);

    /**
     * Social sharing
     */
    new SocialSharing('.js-social-share');

    /**
     * Stepped CTA
     */
    new SteppedCTA();

    /**
     * Sub Menu Scrollbars
     */
    new SubMenu(mobileBreakpoint);

    /**
     * SVG4Everybody
     */
    new Svg4Everybody();

    /**
     * Object fit polyfill
     */
    objectFitImages();

    // Select2 Example
    // new Select2();
    //
    // $('.js-sorter').select2({
    //     minimumResultsForSearch: -1,
    //     width: '100%'
    // });

    // Perfect Scrollbar Example
    // addScrollbars () {
    //     for (let i = 0; i < this.$filterLists.length; i++) {
    //         this.scrollbars.push(new Ps(this.$filterLists[i]));
    //     }
    // }
    //
    // updateScrollbars () {
    //     this.scrollbars.forEach((ps) => ps.update());
    // }

    // Perfect Scrollbar Example
    // addScrollbars () {
    //     for (let i = 0; i < this.$filterLists.length; i++) {
    //         this.scrollbars.push(new Ps(this.$filterLists[i]));
    //     }
    // }
    //
    // updateScrollbars () {
    //     this.scrollbars.forEach((ps) => ps.update());
    // }

}(jQuery));
